import axios from 'axios'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import {AnimaBaixo2} from '../../../../../../_metronic/assets/animation/styles'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {FormEditeFields} from '../../components/formFieldsEdit/FormFieldsEdit'
import {EnterprisesListWrapper} from './linkedEnterprises/enterprises-list/EnterprisesList'
import {LicensesListWrapper} from './linkedLicenses/components/linkedLicenses-list/LicensesList'
import {PropertiesListWrapper} from './linkedProperties/property-list/PropertiesList'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const EditeFields: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const {uuid} = useParams()

  function deleteMsgLicense() {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
      title: intl.formatMessage({id: 'FIELD.SWAL_DELETE_QUESTION'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deleteFields(uuid)
      }
    })
  }

  async function deleteFields(uuid: string) {
    try {
      await axios.delete(`${API_URL}/v1/fields/${uuid}`)
      Swal.fire({
        icon: 'success',
        title: intl.formatMessage({id: 'FIELD.SWAL_DELETE'}),
        showConfirmButton: false,
        timer: 2000,
      })
      navigate('/fields')
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'FIELD.SWAL_DELETE_ERROR'}),
        showConfirmButton: false,
        timer: 1500,
      })
    }
  }
  return (
    <>
      <AnimaBaixo2>
        <ul className='nav'>
          <div
            className='card d-flex justify-content-between g-1 py-3 px-6 mb-3'
            style={{
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <div
              className='card d-flex'
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                width: '95%',
              }}
            >
              <li className='nav-item  me-3'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7 active'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_1'
                >
                  {intl.formatMessage({id: 'COMMON.DATA_EDIT'})}
                </a>
              </li>
              <li className='nav-item me-3'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_2'
                >
                  {intl.formatMessage({id: 'MENU.LINKED_PROPERTIES'})}
                </a>
              </li>

              <li className='nav-item me-3'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_3'
                >
                  {intl.formatMessage({id: 'MENU.LINKED_ENTERPRISES'})}
                </a>
              </li>

              {/* {licenses.control_ContractPayments === true && ( */}
              <li className='nav-item me-3'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_4'
                >
                  {intl.formatMessage({id: 'MENU.LINKED_LICENSE'})}
                </a>
              </li>
            </div>
            <div
              className='card d-flex'
              style={{
                flexDirection: 'row',
                alignItems: 'flex-end',
                width: '5%',
              }}
            >
              <li className='nav-item me-3'>
                <a
                  type='button'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_5'
                  className=' btn btn-sm btn-icon btn-light-danger p-1'
                  title='Excluir Contrato'
                >
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-5' />
                </a>
              </li>
            </div>
          </div>
        </ul>

        <div className='tab-content mt-9' id='myTabContent'>
          <div className='tab-pane fade active show' id='kt_tab_pane_1' role='tabpanel'>
            <FormEditeFields />
          </div>
          <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
            <PropertiesListWrapper />
          </div>
          <div className='tab-pane fade' id='kt_tab_pane_3' role='tabpanel'>
            <EnterprisesListWrapper />
          </div>
          <div className='tab-pane fade' id='kt_tab_pane_4' role='tabpanel'>
            <LicensesListWrapper />
          </div>

          <div className='tab-pane fade' id='kt_tab_pane_5' role='tabpanel'>
            <div id='kt_account_deactivate' className='card '>
              <div className='card-body border-top'>
                <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed  p-6'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2tx svg-icon-danger me-4'
                  />

                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <h4 className='text-gray-800 fw-bolder'>
                        {intl.formatMessage({id: 'FIELD.DELETE_MESSAGE'})}
                      </h4>
                      <div className='fs-7 text-gray-600'>
                        {intl.formatMessage({id: 'COMMON.MESSAGE_NOT_REVERT'})}
                        <br />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flex justify-content-end py-5 px-9'>
                  <button
                    id='kt_account_deactivate_account_submit'
                    type='submit'
                    className='btn btn-sm btn-light-danger fw-bold'
                    onClick={deleteMsgLicense}
                  >
                    {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimaBaixo2>
    </>
  )
}

export {EditeFields}
